import SocialBar from "../components/SocialBar/SocialBar";

export default function TerminosYCondiciones() {
  return (
    <section
      className="bg-dark-gray relative text-white px-6 md:px-12 lg:px-20 py-12 md:py-20 bg-cover bg-center"
      style={{ backgroundImage: "url('/images/fondoBlanco.webp')" }}
    >
      {/* dark overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-60"></div>

      <div className="relative mx-auto text-center max-w-7xl">
        {/* --- Header --- */}
        <h2 className="text-white text-4xl md:text-6xl font-extrabold mb-6 md:mb-10">
          TÉRMINOS Y CONDICIONES
        </h2>

        <p className="text-gray-300 text-lg md:text-2xl mb-16 max-w-4xl mx-auto px-4">
          Conoce las políticas que rigen el uso de nuestra plataforma y
          servicios.
        </p>

        {/* --- Content wrapper --- */}
        <div className="text-left mx-auto max-w-5xl space-y-14 text-gray-200 text-lg md:text-xl leading-relaxed px-4">
          {/* 1. Generalidades */}
          <section>
            <h3 className="text-2xl font-bold mb-4">1. Generalidades</h3>
            <p>
              Bienvenido a <strong>OMOVA Carbon Fiber</strong>. Al acceder y
              utilizar este sitio, aceptas cumplir con los siguientes términos y
              condiciones. Si no estás de acuerdo con alguno de estos términos,
              te recomendamos no utilizar nuestro sitio.
            </p>
          </section>

          {/* 2. Compras */}
          <section>
            <h3 className="text-2xl font-bold mb-4">2. Compras</h3>
            <p>
              Las compras se realizan en la plataforma de{" "}
              <a
                href="https://omova-comercializadora.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="underline"
              >
                Omova Carbon Fiber
              </a>{" "}
              , no se pueden realizar compras en este sitio. Para realizar un
              pedido en la plataforma, es necesario completar un registro a
              través de nuestro{" "}
              <a
                href="/form"
                rel="noopener noreferrer"
                className="text-primary-green underline hover:text-green-400 transition-colors"
              >
                formulario
              </a>{" "}
              en línea. Una vez aprobado el acceso, podrás explorar nuestro
              catálogo, seleccionar los productos deseados y proceder con tu
              pedido. El pago debe realizarse mediante transferencia
              electrónica, enviando el comprobante a través de WhatsApp o
              subiéndolo a nuestra plataforma. Confirmaremos y procesaremos tu
              pedido una vez verificada la transferencia.
            </p>

            <p className="mt-4">
              Las modificaciones o cancelaciones de pedidos son posibles,
              siempre y cuando te comuniques con nosotros a la brevedad a través
              de <strong>info@omovacarbonfiber.com</strong> o por WhatsApp.
              Intentaremos atender tu solicitud antes de que el pedido sea
              procesado y enviado.
            </p>
          </section>

          {/* 3. Facturación */}
          <section>
            <h3 className="text-2xl font-bold mb-4">3. Facturación</h3>
            <p>
              Las facturas pueden ser solicitadas durante el proceso de compra y
              serán cargadas en la orden una vez confirmado el pago. Para
              cualquier duda o asistencia adicional, puedes contactarnos a
              través de nuestros canales de atención al cliente.
            </p>
          </section>

          {/* 4. Descuentos y promociones */}
          <section>
            <h3 className="text-2xl font-bold mb-4">
              4. Descuentos y promociones
            </h3>
            <p>
              Ofrecemos descuentos para compras al por mayor, ajustando los
              precios según el volumen y la frecuencia de compra. Si contamos
              con promociones o descuentos especiales, serás informado a través
              de los datos de contacto registrados. Para más información, puedes
              comunicarte con nosotros.
            </p>
          </section>

          {/* 5. Envíos */}
          <section>
            <h3 className="text-2xl font-bold mb-4">5. Envíos</h3>
            <p>
              En <strong>OMOVA Carbon Fiber</strong> realizamos envíos a todo
              México. No ofrecemos envíos internacionales por el momento. Una
              vez que tu pedido sea enviado, te proporcionaremos un número de
              rastreo a través de WhatsApp. Todos los envíos de fibra de carbono
              pueden rastrearse, aunque algunas paqueterías no ofrecen rastreo
              para envíos de resina.
            </p>
            <p className="mt-4">
              El costo del envío varía según tu ubicación, pero ofrecemos un
              descuento del 2% del valor de tu pedido. Si el pago se recibe
              antes de la 1:00 pm, trataremos de enviar tu pedido el mismo día,
              aunque el tiempo de preparación puede variar según la cantidad de
              pedidos pendientes.
            </p>
          </section>

          {/* 6. Garantías */}
          <section>
            <h3 className="text-2xl font-bold mb-4">6. Garantías</h3>
            <p>
              Todos nuestros productos están garantizados en cuanto a su calidad
              y características especificadas. La garantía cubre cualquier
              defecto o inconsistencia con las especificaciones anunciadas, pero
              no cubre alteraciones o daños por uso indebido del producto.
            </p>
            <p className="mt-4">
              Para hacer válida una garantía, es necesario contactar a nuestro
              equipo de atención al cliente, quien te guiará en el proceso. La
              garantía tiene una duración de 30 días desde la recepción del
              producto.
            </p>
          </section>

          {/* 7. Devoluciones y reembolsos */}
          <section>
            <h3 className="text-2xl font-bold mb-4">
              7. Devoluciones y reembolsos
            </h3>
            <p>
              Nuestra política de devoluciones te permite devolver un producto
              dentro de los 30 días posteriores a la entrega, siempre que esté
              en su estado original. Los costos de envío de la devolución corren
              por cuenta del cliente. No aceptamos devoluciones de todos los
              productos, consulta nuestras políticas de compra.
            </p>
            <p className="mt-4">
              Para solicitar un reembolso, es necesario comunicar la devolución
              a <strong>info@omovacarbonfiber.com</strong>. Una vez confirmada,
              el reembolso se procesará en un plazo de 48 a 72 horas hábiles
              utilizando el mismo método de pago original.
            </p>
          </section>

          {/* 8. Productos */}
          <section>
            <h3 className="text-2xl font-bold mb-4">8. Productos</h3>
            <p>
              En <strong>OMOVA Carbon Fiber</strong> ofrecemos una amplia gama
              de productos, incluyendo tejidos de fibra de carbono, resinas,
              catalizadores y productos complementarios. Nuestro catálogo en
              línea proporciona información detallada sobre las especificaciones
              técnicas de cada producto.
            </p>
            <p className="mt-4">
              También ofrecemos un muestrario gratuito compuesto por 7 llaveros
              elaborados con diferentes tejidos de fibra de carbono, disponible
              para quienes cumplan con nuestros criterios.
            </p>
          </section>

          {/* 9. Plataforma */}
          <section>
            <h3 className="text-2xl font-bold mb-4">9. Plataforma</h3>
            <p>
              Para acceder a nuestros productos y servicios, es necesario
              registrarse en nuestra plataforma mediante el formulario
              disponible en nuestro sitio web. Una vez registrado y aprobado,
              tendrás acceso a nuestro catálogo, podrás realizar pedidos, enviar
              comprobantes de pago y ver precios exclusivos.
            </p>
            <p className="mt-4">
              En la plataforma puedes consultar tu historial de pedidos y
              cotizaciones, además de actualizar tu información de contacto
              cuando lo necesites.
            </p>
          </section>

          {/* 10. Pagos */}
          <section>
            <h3 className="text-2xl font-bold mb-4">10. Pagos</h3>
            <p>
              Aceptamos pagos mediante transferencia electrónica o depósitos a
              nuestras cuentas bancarias. Tras realizar el pago, es necesario
              subir el comprobante a nuestra plataforma o enviarlo por WhatsApp.
              Confirmamos tu pago por este medio para asegurar la correcta
              gestión de tu pedido.
            </p>
            <p className="mt-4">
              Todos los métodos de pago son seguros, utilizando protocolos
              avanzados para proteger tus datos. No ofrecemos opciones de pago a
              plazos; el pago debe hacerse en una sola exhibición.
            </p>
          </section>

          {/* 11. Soporte técnico */}
          <section>
            <h3 className="text-2xl font-bold mb-4">11. Soporte técnico</h3>
            <p>
              Nuestro equipo de atención al cliente está disponible para
              asistirte con cualquier duda o necesidad. Puedes contactarnos a
              través de <strong>info@omovacarbonfiber.com</strong> o por
              WhatsApp. Si bien ofrecemos asesoría para la selección de
              productos, no brindamos asistencia técnica sobre la fabricación o
              reparación de fibra de carbono.
            </p>
            <p className="mt-4">
              Disponemos de guías de uso y tutoriales en nuestra plataforma para
              ayudarte a aprovechar al máximo nuestras funcionalidades.
            </p>
          </section>

          {/* 12. Privacidad y seguridad */}
          <section>
            <h3 className="text-2xl font-bold mb-4">
              12. Privacidad y seguridad
            </h3>
            <p>
              En <strong>OMOVA Carbon Fiber</strong>, la protección de tu
              información personal es una prioridad. Utilizamos protocolos de
              seguridad avanzados y encriptación para garantizar que tus datos
              estén seguros en todo momento.
            </p>
            <p className="mt-4">
              Tu información personal se utiliza únicamente para procesar
              pedidos, brindar acceso a nuestra plataforma y mejorar nuestros
              servicios. No compartimos tu información con terceros, salvo para
              completar transacciones con procesadores de pagos o servicios de
              envío.
            </p>
            <p className="mt-4">
              Puedes solicitar la eliminación de tu cuenta y datos asociados
              contactando a <strong>info@omovacarbonfiber.com</strong>, o darte
              de baja de nuestras comunicaciones en cualquier momento.
            </p>
          </section>
          <SocialBar />
        </div>
      </div>
    </section>
  );
}
